import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M12.153 18.6c-3.742-3.118-7.953-.255-7.953-.255V4.763s4.18-3.658 7.828.223c0 0 3.026 2.29 1.154 2.958-2.058.732-2.401-1.559-1.247-2.8"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M12.301 18.47c3.743-3.117 7.712-.124 7.712-.124V4.762s-4.18-3.658-7.828.223"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M2.6 5.822V18.98c0 .647.507 1.164 1.141 1.164h7.29M12.934 20.144h7.48c.634 0 1.141-.517 1.141-1.164V5.886"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const ArticlesIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
